import { platformApi } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useNicheSuspects(groupCodes = []) {
  const queryKey = ['nicheSuspects', groupCodes];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      const searchParams = new URLSearchParams([
        ...groupCodes.map((code) => ['groupCodes', code]),
      ]);

      return platformApi.get('niche/suspects', { searchParams, signal }).json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60,
  });

  return { query, cancel: () => queryClient.cancelQueries({ queryKey }) };
}
